import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const { category } = useParams();
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [sort, setSort] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { category: category || "all", sort, limit: 60 } })
      .then(r => setProducts(r.data || []))
      .finally(()=>setLoading(false));
  }, [category, sort]);

  return (
    <section className="py-12 lg:py-16" data-testid="shop-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="eyebrow">Boutique</div>
          <h1 className="font-serif-bm text-4xl md:text-5xl mt-3 capitalize" data-testid="shop-title">
            {category ? t(`nav.${category}`) : t("nav.shop")}
          </h1>
        </div>
        <div className="flex justify-end items-center mb-6">
          <select value={sort} onChange={e=>setSort(e.target.value)} className="bm-input max-w-xs" data-testid="sort-select">
            <option value="">{t("common.newest")}</option>
            <option value="price_asc">{t("common.price_low")}</option>
            <option value="price_desc">{t("common.price_high")}</option>
            <option value="name">{t("common.name_az")}</option>
          </select>
        </div>
        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {Array.from({length:8}).map((_,i)=> <div key={i} className="aspect-[4/5] bg-[#f4f4f4] rounded-2xl animate-pulse"/>)}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-[var(--bm-muted)]">No products found</div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i}/>)}
          </div>
        )}
      </div>
    </section>
  );
}
